import { render } from "./JobList.vue?vue&type=template&id=52bc2432&scoped=true"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"

import "./JobList.vue?vue&type=style&index=0&id=52bc2432&scoped=true&lang=css"
import "./JobList.vue?vue&type=style&index=1&id=52bc2432&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bc2432"]])

export default __exports__